import { Blurhash } from "react-blurhash";
import { useState, useEffect } from "react";

const BlurhashSlide = ({ imageUrl, blurhash }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!imageUrl) return;

        const img = new Image();
        img.src = imageUrl;
        img.onload = () => setLoaded(true);
    }, [imageUrl]);

    return (
        <div style={{ position: "relative", width: "100%", height: "650px" }}>
            {!loaded && blurhash && (
                <Blurhash
                    hash={blurhash}
                    width="100%"
                    height="100%"
                    resolutionX={32}
                    resolutionY={32}
                    punch={1}
                />
            )}

            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: loaded ? `url(${imageUrl})` : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "50% 50%",
                    transition: "opacity 300ms ease",
                    opacity: loaded ? 1 : 0,
                }}
            />
        </div>
    );
};

export default BlurhashSlide;
